import React from "react";

import { ButtonStandard, ModalBase, Text } from "@performyard/py-components";

type ExitWizardModalProps = {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export const ExitWizardModal = ({ isOpen, onClose, onConfirm }: ExitWizardModalProps) => (
	<ModalBase isOpen={isOpen} onClose={onClose} dangerouslySetClassName="w-[432px]">
		<div className="flex flex-col gap-6 px-6 pb-6">
			<div className="flex flex-col gap-0">
				<Text size="sub-heading" weight="semi-bold" dangerouslySetClassName="text-center">
					Exit Wizard
				</Text>
				<div className="flex flex-col gap-0 pr-6 pl-6">
					<Text size="paragraph-2" weight="regular" dangerouslySetClassName="text-center">
						Your review cycle configuration will not be saved. Are you sure you want to exit?
					</Text>
				</div>
			</div>
			<div className="flex w-full flex-wrap justify-center gap-3">
				<ButtonStandard
					size="large"
					variant="outline"
					color="neutral"
					dangerouslySetClassName="w-auto px-[16px]"
					onClick={onClose}
				>
					Cancel
				</ButtonStandard>
				<ButtonStandard
					size="large"
					color="primary"
					dangerouslySetClassName="w-auto px-[16px]"
					onClick={onConfirm}
				>
					Yes, Exit Wizard
				</ButtonStandard>
			</div>
		</div>
	</ModalBase>
);
